"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckboxDisableFormat = CheckboxDisableFormat;

var _react = _interopRequireDefault(require("react"));

var _Checkbox = _interopRequireDefault(require("@eig-builder/core-ui/Checkbox"));

function CheckboxDisableFormat(params) {
  return /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
    disabled: true,
    checked: params.value,
    color: "primary",
    onChange: function onChange() {
      return params.colDef.clickFunction(params.data, params.value);
    }
  });
}